import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";

import QRCode from "react-qr-code";

const QRDialog = ({ open, onClose, uploadId }) => {
  const mobileUrl = `${window.location.origin}/mobile-upload/${uploadId}`;

  return (
    <Dialog open={open} maxWidth="xs" fullWidth onClose={onClose}>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        Scan QR
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          gap={2}
          py={2}
        >
          <QRCode value={mobileUrl} size={220} />

          <Typography variant="body2" textAlign="center">
            Scan this QR code using your mobile phone to capture and upload the
            document.
          </Typography>

          <Typography
            variant="caption"
            sx={{
              wordBreak: "break-all",
            }}
          >
            {mobileUrl}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default QRDialog;
